var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPhoneNumber = function SvgPhoneNumber(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "katman 2",
    width: 17.368,
    height: 17.368,
    viewBox: "0 0 17.368 17.368",
    alt: "phone number",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 114",
    style: {
      fill: "none"
    },
    d: "M0 0h17.368v17.368H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 20820",
    d: "M15.239 2.644H8.4v-.268A1.878 1.878 0 0 0 6.52.5h-2a1.878 1.878 0 0 0-1.876 1.876v.268h-.268A1.878 1.878 0 0 0 .5 4.52v10.719a1.878 1.878 0 0 0 1.876 1.876h12.863a1.878 1.878 0 0 0 1.876-1.876V4.52a1.878 1.878 0 0 0-1.876-1.876zM4.252 2.376a.268.268 0 0 1 .268-.268h2a.268.268 0 0 1 .268.268v8.039a.268.268 0 0 1-.268.268h-2a.268.268 0 0 1-.268-.268zm11.255 12.863a.268.268 0 0 1-.268.268H2.376a.268.268 0 0 1-.268-.268V4.52a.268.268 0 0 1 .268-.268h.268v6.164a1.878 1.878 0 0 0 1.876 1.875h2a1.878 1.878 0 0 0 1.88-1.876V4.252h6.843a.268.268 0 0 1 .268.268z",
    transform: "translate(-.5 -.5)",
    style: {
      fill: "#c4c4c4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 20821",
    d: "M21.48 8.143h-4.622a.8.8 0 0 0-.8.8V11.5a.8.8 0 0 0 .8.8h4.622a.8.8 0 0 0 .8-.8V8.947a.8.8 0 0 0-.8-.804zm-.8 2.555h-3.018v-.947h3.015zm-2.7 2.154h-.695a.8.8 0 0 0 0 1.608h.695a.8.8 0 1 0 0-1.608zm3.076 0h-.695a.8.8 0 0 0 0 1.608h.695a.8.8 0 0 0 0-1.608zm-3.076 2.153h-.695a.8.8 0 1 0 0 1.608h.695a.8.8 0 1 0 0-1.608zm3.076 0h-.695a.8.8 0 0 0 0 1.608h.695a.8.8 0 1 0 0-1.608z",
    transform: "translate(-7.718 -4.047)",
    style: {
      fill: "#c4c4c4"
    }
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPhoneNumber, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/phoneNumber.9d7bf467.svg";
export { ForwardRef as ReactComponent };